import { api, ApiTags } from '../../api';

import { SlidesResponse } from './types';

const slidesApi = api.injectEndpoints({
    endpoints: build => ({
        /**
         * Получить список слайдов для карусели на главной странице
         * GET /api/slides
         */
        getSlides: build.query<SlidesResponse, void>({
            query: () => '/slides',
            providesTags: [ApiTags.Slides],
        }),
    }),
});

export const { useGetSlidesQuery } = slidesApi;
